import { type ReactNode, useState } from 'react';

import { EmbedConfig } from 'utils/embed.utils';

import { NofomoStoreContext } from './context';
import {
  createNofomoStore,
  initNofomoStore,
  type NofomoStoreReturnType,
} from './zustand';

interface NofomoStoreProviderProps {
  embed?: EmbedConfig;
  children: ReactNode;
}

export const NofomoStoreProvider = ({
  embed,
  children,
}: NofomoStoreProviderProps) => {
  // Embed: seeded once, a page can only enter or leave an embed by being
  // loaded again.
  const [store] = useState<NofomoStoreReturnType>(() =>
    createNofomoStore(initNofomoStore(embed)),
  );

  return (
    <NofomoStoreContext.Provider value={store}>
      {children}
    </NofomoStoreContext.Provider>
  );
};
